// extracted by mini-css-extract-plugin
export default {"container":"Y1xb4trlQPpC9F2HiHEC","tab":"XOLEdBAzB7FbBYMcXy3D","active_tab":"N8Q0XGANNc0w0dIqzAoq"};